import { createFeatureScope } from 'bundles/product-features';

export const { ProductFeaturesQuery, useProductFeatures, withProductFeatures } = createFeatureScope({
  enterprise: {
    enableAiCoach: true /* value is unused */,
  },
});
